import LandiBustBg from '../assets/images/landi-bust-bg.png'
import SambiBustBg from '../assets/images/sambi-bust-bg.png'
import LocumBustBg from '../assets/images/locum-bust-bg.png'
import LandiBust from '../assets/images/landi-bust.png'
import SambiBust from '../assets/images/sambi-bust.png'
import LocumBust from '../assets/images/locum-bust.png'
import useIsMobile from '../hooks/useIsMobile'
import { cn } from '../utils/classNames'

const teamMembers = [
  {
    name: 'LANDI RADEMEYER',
    qualifications: ['M.Ost 2016', 'Bach. Applied Science (Human Biology) 2012', 'ACC Registered'],
    imageMobile: LandiBust,
    imageDesktop: LandiBustBg,
    bio: [
      'Hello, I’m Landi, a dedicated and experienced osteopath committed to helping my patients achieve optimal health and well-being.',
      'I am passionate about helping individuals achieve their goals of pain management, enhanced flexibility, competing in their desired events and supporting the mother-baby dyad. I am originally from South Africa and have called NZ home since 2000. My training was at Unitec, where I gained a Bachelor of Applied Science (Human Biology) and Master of Osteopathy. Since then I have completed several courses in pediatrics, visceral (mobilization of organs), manipulation and many more.',
      'As an Osteopath I provide a wide variety of skills and knowledge to provide personalised treatments for all ages. I regularly look at the body as a puzzle and enjoy seeing how the pieces fit together, or searching for the missing piece to achieve optimum health.',
      'I love to see the impact that Osteopathy can make on the lives of others and look forward to using the skills of hands-on medicine to impact lives.',
    ],
  },
  {
    name: 'SAMBI NELSON',
    qualifications: [
      'M.Ost 2016',
      'B.A. Communications 2008',
      'Certified Mat Pilates Level 1 Instructor 2010',
      'Pilates Reformer and Trapeze Table Level 1 2011',
    ],
    imageMobile: SambiBust,
    imageDesktop: SambiBustBg,
    bio: [
      "Hello, I'm Sambi, I grew up in Japan, but moved to Rotorua in 2016, after completing my Osteopathy degree in the UK.",
      'I love working with my patients to help them not only recover from acute pain or injury, but also by working with them long term to improve general well being, prevent injury, or manage chronic pain. I believe that by educating our patients about their body and pain, we can empower them to live more fulfilling day to day lives.',
      'As an Osteopath I treat patients using a variety of techniques including structural, cranial, visceral osteopathy, as well as prescribing movement or exercises which complement the hands on treatment.',
      'I also have a background as a Pilates instructor and believe in movement as medicine. On days I am not treating patients in the clinic, you will generally find me teaching Pilates classes, or out and about with my 3 kids, taking advantage of the nature Rotorua has to offer.',
    ],
  },
]

function Team() {
  const isMobile = useIsMobile()

  return (
    <main className='relative w-full'>
      <div className='container'>
        <h1 className='mb-6 font-serif text-5xl font-bold text-blue-dark lg:mb-0'>Meet the team</h1>
        {teamMembers.map((member, index) => (
          <TeamMember key={member.name} member={member} isMobile={isMobile} isReverse={index % 2 !== 0} />
        ))}
      </div>
    </main>
  )
}

function TeamMember({ member, isMobile, isReverse }) {
  const { name, qualifications, imageMobile, imageDesktop, bio } = member

  return (
    <section className='grid items-center gap-12 py-4 lg:grid-cols-2 lg:items-start lg:py-12'>
      <div className={cn('relative', isReverse && 'lg:col-start-2')}>
        <img
          src={isMobile ? imageMobile : imageDesktop}
          className='mx-auto block h-auto max-w-full'
          alt={name}
          width='700'
          height='500'
        />
      </div>
      <div className={cn(isReverse && 'lg:col-start-1 lg:row-start-1')}>
        <h2 className='mb-3 text-lg font-bold leading-none text-blue-dark'>{name}</h2>
        {qualifications.map((qualification, index) => (
          <p
            key={qualification}
            className={cn('text-blue-dark/60', index === qualifications.length - 1 && 'mb-3')}
          >
            {qualification}
          </p>
        ))}
        {bio.map((paragraph) => (
          <p key={paragraph} className='mb-3'>
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  )
}

export default Team
